export default "__VITE_ASSET__BFZPc9Yw__"